import { TokenStorageService } from './../../../../@core/services/token-storage.service';
import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ApiService } from '@core/services/api.service';
import { CoreConfigService } from '@core/services/config.service';
import Stepper from 'bs-stepper';

@Component({
  selector: 'app-voucher',
  templateUrl: './voucher.component.html',
  styleUrls: ['./voucher.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class VoucherComponent implements OnInit {

  public contentHeader: object;
  public TDNameVar;
  public TDEmailVar;
  public quantity: any;
  public network: any;
  productCode: any;
  productName: any;
  public amount: any;
  trxPin: any;
  public transactionRef: any = {
    trans_id: '',
    created_at: ''
  }
  public facebookVar;
  public googleVar;
  public linkedinVar;
  public landmarkVar;
  public addressVar;
  submitted: boolean = false
  disable: boolean = false
  public siteSettings: any = {
    site_logo: '',
    site_name: ''
  };

  public selectBasic = [];
  public selectProducts = [];

  public selectMulti = [{ name: 'English' }, { name: 'French' }, { name: 'Spanish' }];
  public selectMultiSelected;

  // private
  private horizontalWizardStepper: Stepper;
  private verticalWizardStepper: Stepper;
  private modernWizardStepper: Stepper;
  private modernVerticalWizardStepper: Stepper;
  private bsStepper;
  public user: any

  constructor(
    private tokenStorage: TokenStorageService,
    private _coreConfigService: CoreConfigService,
    private api: ApiService
  ) {
    
  }


  print() {
    let printContents, popupWin;
		printContents = document.getElementById('print-receipt').innerHTML;
		popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
		if(popupWin){
			popupWin.document.open();
			popupWin.document.write(`
				<html>
					<head>
						<title>Transaction Receipt</title>
						<style type="text/css">
            body {
              -webkit-print-color-adjust: exact;
            }
              p {
                font-family: "Times New Roman";
              }

              .padding-main-divcls{
                padding: 5px;
              }

              .text-center{
                text-align: center
              }
              .width-full{
                width: 100%;
              }

              .box{
                  border-style: solid;
                  border-width: 1px;
                  width: 65px;
                  height: 100px;
                  float: right;
                  margin-right: 50px;
                  font-size: 10px;
                  padding: 5px;
              }
              .box-divcls{
                width: 100%;
                display: inline-block;
              }

              .TermsConditionTable, tr , td {
								padding: 4px !important;
							}
							tr, td {
								page-break-inside: avoid !important;
							}

							.break-after{
								page-break-after: always;
							}
              .top-border-cls{
                border-top: solid black 1.0pt;
              }
            </style>
            <body onload="window.print();window.close()">${printContents}</body>
          </head>
        </html>
      `)
      popupWin.document.close();
    }

  }

  /**
   * Horizontal Wizard Stepper Next
   *
   * @param data
   */
  horizontalWizardStepperNext(data) {
    if (data.form.valid === true) {
      this.horizontalWizardStepper.next();
    }
  }
  /**
   * Horizontal Wizard Stepper Previous
   */
  horizontalWizardStepperPrevious() {
    this.horizontalWizardStepper.previous();
  }

  /**
   * On Submit
   */
  onSubmit() {
    alert('Submitted!!');
    return false;
  }
  
  selectNetwork($event) {
    console.log($event)
    this.network = $event
    this.fetchProducts(this.network)
  }

  selectProduct($event) {
    console.log($event)
    this.productCode = $event.id
    this.productName = $event.display_name
    this.amount = $event.amount
  }

  fetchProducts(network) {
    const param = {
      serviceID: 13,
      category: network
    }
    this.api.post('category-products', param).subscribe((response: any) => {
      this.selectProducts = response.data
    });
  }

  proceedPayment(accountDetailsForm) {
    if (!this.trxPin) {
      this.api.alerts("top-end", "error", "Please, enter transaction PIN")
      return;
    }
    // if (this.trxPin !== this.user.wallet_key) {
    //   this.api.alerts("top-end", "error", "Incorrect transaction PIN")
    //   return;
    // }

    // if (this.user.wallet_key === '') {
    //   this.api.alerts("top-end", "error", "Transaction PIN not set. You will be redirected.")
    //   setTimeout(() => {
    //     window.location.href = '/profile'
    //   }, 2500);
    //   return;
    // }

    this.submitted = true
    this.disable = true
    const param = {
      network: this.network,
      quantity: this.quantity,
      planId: this.productCode,
      amount: this.amount,
      pin: this.trxPin
    }
    this.api.post('buydatacard', param).subscribe((response: any) => {
      this.submitted = false
      this.disable = false
      if (response.success === true) {
        this.api.alerts("top-end", "success", response.message)
        this.transactionRef = response.transaction
        this.tokenStorage.saveUser(response.customer);
        this.horizontalWizardStepperNext(accountDetailsForm)
      }else{
        this.api.alerts("top-end", "error", response.message)
      }
    });
    
  }

  startAgain() {
    window.location.reload()
  }


  // Lifecycle Hooks
  // -----------------------------------------------------------------------------------------------------

  /**
   * On Init
   */
  ngOnInit() {
    if (this.tokenStorage.getToken()) {
      this.user = this.tokenStorage.getUser();
    }

    this.api.externalGet('list-service-category&serviceID=13').subscribe((response: any) => {
      this.selectBasic = response.data; 
    });
    this._coreConfigService.sysConfig().subscribe(config => {
      console.log("site settings: ", config)
      this.siteSettings = config.data;
    });

    this.horizontalWizardStepper = new Stepper(document.querySelector('#stepper1'), {});

    this.bsStepper = document.querySelectorAll('.bs-stepper');

    // content header
    this.contentHeader = {
      headerTitle: 'Recharge Card',
      actionButton: false,
      breadcrumb: {
        type: '',
        links: [
          {
            name: 'Home',
            isLink: true,
            link: '/dashboard'
          },
          {
            name: 'Recharge Card',
            isLink: false
          }
        ]
      }
    };
  }

}